<template>
    <AppModal
        v-if="hasRole(modalShowVal)"
        :size="size"
        :backdrop="true"
        grid="'grid'"
        class="app-gallery-modal"
        transparent-modal
    >
        <AppModalContent class="!bg-transparent !shadow-none">
            <AppModalHeader
                class="!fixed"
                :heading-text="'Image.png'"
                classes="!bg-transparent !fixed m-auto !p-6 !pb-4 h-[72px] !text-white"
                icon-shape="chevron-left"
                heading-icon="image"
                heading-icon-type="fas"
                :is-close-icon="true"
                @on-header-toggle="toggleModal"
            >
                <template #modalHeaderRight>
                    <!-- <AppButton
                        :prefix_icon="'download'"
                        icon-type="fal"
                        icon-class="text-2xl"
                        classes="!font-semibold btn-link !text-white !text-base"
                        type="button"
                    /> -->
                    <div
                        class="modal-header-download cursor-pointer flex gap-2 text-sm font-normal"
                    >
                        <fa class="h-[20px]" :icon="['fal', 'download']" />
                        Download
                    </div>
                </template>
            </AppModalHeader>
            <AppModalBody classes="overflow-hidden !p-0">
                <!-- <pre>{{ chat }}</pre> -->
                <Swiper
                    ref="swiperRef"
                    :style="{
                        '--swiper-navigation-color': '#fff',
                        '--swiper-pagination-color': '#fff',
                    }"
                    :space-between="5"
                    :navigation="false"
                    :thumbs="{ swiper: thumbsSwiper }"
                    :modules="modules"
                    class="mySwiper2 mb-4"
                    :zoom="true"
                    @swiper="onSwiper"
                    @slide-change="updateSlideInfo"
                >
                    <SwiperSlide
                        v-for="(image, index) in chat.content"
                        :key="index"
                    >
                        <div class="swiper-zoom-container">
                            <img
                                :key="index"
                                class="bg-gray-100 text-sm h-[558px] object-cover"
                                :src="image"
                            />
                        </div>
                    </SwiperSlide>
                </Swiper>
                <Swiper
                    :space-between="8"
                    :slides-per-view="6"
                    :free-mode="true"
                    :watch-slides-progress="true"
                    :modules="[Thumbs]"
                    class="mySwiper"
                    @swiper="setThumbsSwiper"
                >
                    <SwiperSlide
                        v-for="(image, index) in chat.content"
                        :key="index"
                        class="!w-[96px]"
                    >
                        <img
                            :key="index"
                            class="bg-gray-100 text-sm !h-[77px] object-cover w-full"
                            :src="image"
                        />
                    </SwiperSlide>
                </Swiper>
            </AppModalBody>
            <div class="bottom-controls text-white m-auto mt-12">
                <span>Image {{ currentSlide }} / {{ totalSlides }}</span>
            </div>
        </AppModalContent>
    </AppModal>
</template>
<script setup>
import { ref, defineExpose, onMounted } from 'vue';
import AppModal from '@/components/appComponents/modal/AppModal.vue';
import AppModalHeader from '@/components/appComponents/modal/AppModalHeader.vue';
import AppModalBody from '@/components/appComponents/modal/AppModalBody.vue';
import AppButton from '@/components/appComponents/AppButton.vue';
import AppModalContent from '@/components/appComponents/modal/AppModalContent.vue';
import useToggleModal from '@/composables/useToggleModal';
import { Swiper, SwiperSlide } from 'swiper/vue';
import moment from 'moment';
import { Zoom, FreeMode, Navigation, Thumbs, Pagination } from 'swiper/modules';
import 'swiper/css/zoom';
import 'swiper/css/bundle';
import 'swiper/css';
const modules = ref([FreeMode, Navigation, Thumbs, Pagination, Zoom]);
const thumbsSwiper = ref(null);
const setThumbsSwiper = (swiper) => {
    thumbsSwiper.value = swiper;
};
const swiperRef = ref();
const currentSlide = ref(1);
const totalSlides = ref(3);
const onSwiper = (swiper) => {
    totalSlides.value = swiper.slides.length;
};
const formatDate = (date) => {
    return moment(date).format('D/MM/YYYY [at] HH:mm');
};
// const showModal = (modalShowVal) => {
//     console.log(modalShowVal, 'checking modal modalShowVal');
//     openModal(modalShowVal); // directly call openModal
// };
const { openModal, hasRole, toggleModal } = useToggleModal();
const showModal = (modalShowVal) => {
    openModal(modalShowVal); // directly call openModal
};
const props = defineProps({
    modalShowVal: {
        type: String,
        default: '',
        required: true,
    },
    size: {
        type: String,
        default: 'medium',
    },
    chat: {
        type: Object,
    },
});
const updateSlideInfo = (swiper) => {
    // const swiper = swiperRef.value?.swiper;
    // console.log(swiper.realIndex + 1, 'checking active slide');
    currentSlide.value = swiper.realIndex + 1;
};
onMounted(() => {
    if (swiperRef.value) {
        console.log(swiperRef.value.thumbs, 'swiper ref value');
        // swiperRef.value.init;
        // totalSlides.value = swiperRef.value.thumbs.slides.length;
    }
});
defineExpose({
    showModal,
});
</script>
<style lang="css">
/* .app-modal-position {
    top: 0;
}
.app-modal-position .items-normal {
    align-items: normal;
}
.app-modal-position .modal_header h4 {
    @apply !text-white m-auto;
}
.app-modal-position .back-icon-btn {
    @apply !mr-0;
} */
.app-modal-position .swiper-pagination {
    /* @apply !text-white top-7 fixed left-[70px] h-[35px] max-w-[calc(100%-140px)] text-base font-semibold; */
}
.bottom-controls {
    background-color: #3d3c3c;
    border-radius: 99px;
    padding: 8px 24px;
}
.swiper {
    @apply w-full;
}
.mySwiper .swiper-wrapper {
    justify-content: center;
}
</style>
<style lang="css" scoped>
:deep(.modal_backdrop) {
    background-color: rgba(0, 0, 0, 0.8);
}
/* :deep(.app-gallery-modal .modal_header h4 .warp_icon svg) { */
.app-gallery-modal :deep(.modal_header h4) {
    @apply !text-white font-semibold;
}
.app-gallery-modal :deep(.modal_header h4) {
    @apply !text-white font-semibold text-base;
}
.app-gallery-modal :deep(.modal_header h4 .warp_icon){
    @apply w-4 h-4 mr-2;
}
.app-gallery-modal :deep(.modal_header h4 .warp_icon > div) {
    @apply w-4 h-4;
}
.app-gallery-modal :deep(.modal_header h4 .warp_icon svg) {
    @apply !text-red-500 h-[16px];
}
</style>